import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { faqList } from "@/mocks/faqs";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <>
      <Navbar />
      <main>
        <section className="pt-24 md:pt-28">
          <div className="mx-auto w-full max-w-3xl px-4 md:px-6 py-10 md:py-14">
            <nav aria-label="面包屑" className="text-xs text-foreground-500">
              <Link to="/" className="hover:text-primary-700">首页</Link>
              <span className="mx-1.5">/</span>
              <span className="text-foreground-700">常见问题</span>
            </nav>
            <h1 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">常见问题</h1>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              关于泡面番、三分钟短番、下饭番与一口气看完，你想知道的都在这里。
            </p>

            <div className="mt-8 space-y-3">
              {faqList.map((f, i) => (
                <div
                  key={f.q}
                  className="overflow-hidden rounded-2xl border border-background-200/70 bg-background-100"
                >
                  <button
                    type="button"
                    onClick={() => setOpenIdx(openIdx === i ? -1 : i)}
                    aria-expanded={openIdx === i}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <h2 className="font-heading text-base text-foreground-950">{f.q}</h2>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700 transition-transform ${
                        openIdx === i ? "rotate-45" : ""
                      }`}
                    >
                      <i className="ri-add-line" aria-hidden="true" />
                    </span>
                  </button>
                  {openIdx === i && (
                    <p className="px-5 pb-5 text-sm leading-7 text-foreground-600">{f.a}</p>
                  )}
                </div>
              ))}
            </div>

            <div className="mt-10 rounded-2xl bg-accent-900 p-6 text-center text-background-50">
              <h2 className="font-heading text-xl">还有问题没解决？</h2>
              <p className="mt-2 text-sm text-accent-100/80">去番剧库挑一部喜欢的短番，或者给我们发邮件，随时欢迎来聊。</p>
              <div className="mt-5 flex flex-col items-center justify-center gap-3 sm:flex-row">
                <Link
                  to="/library"
                  className="inline-flex items-center gap-2 rounded-full bg-background-50 px-6 py-2.5 text-sm font-medium text-accent-900 whitespace-nowrap transition-colors hover:bg-background-100"
                >
                  <i className="ri-movie-2-line" aria-hidden="true" />
                  去番剧库
                </Link>
                <a
                  href="mailto:hello@xiaoshuikanfan.com"
                  className="inline-flex items-center gap-2 rounded-full bg-accent-800 px-6 py-2.5 text-sm text-background-50 whitespace-nowrap transition-colors hover:bg-accent-700"
                >
                  <i className="ri-mail-line" aria-hidden="true" />
                  联系我们
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}